import React, { PureComponent } from "react";
import { AutoSizer } from "react-virtualized";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

const BORDER_WIDTH = 2;

export default class OptimizerPieChart extends PureComponent {
  render() {
    const { pData, unit } = this.props;

    if (pData === undefined) {
      return <div />;
    }

    const total = pData.reduce((a, b) => a + b.value, 0);

    return (
      <AutoSizer>
        {({ height, width }) => (
          <PieChart height={height} width={width}>
            <Pie data={pData} innerRadius={30} outerRadius={50} fill="#8884d8" paddingAngle={6} dataKey="value">
              {pData.map((entry, index) => {
                return (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.color}
                    fillOpacity={entry.isOutline ? 0.5 : 1}
                    strokeWidth={BORDER_WIDTH}
                    stroke={entry.color}
                  />
                );
              })}
            </Pie>
            <Tooltip
              formatter={(value, name, props) => unit + value + " (" + Math.round((props.value / total) * 100) + "%)"}
            />
          </PieChart>
        )}
      </AutoSizer>
    );
  }
}
